import { createAction } from "redux-actions";
import { takeLatest, put, select, call } from "redux-saga/effects";
import axios from "axios";
import moment from "moment";
import { queryParams } from "../../../../../../utils/queryParams";

export const FETCH_CURRENT_USER =
  "sagas/attendance/average_number_of_clients_per_class/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS =
  "sagas/attendance/average_number_of_clients_per_class/FETCH_CURRENT_USER_SUCCESS";

export const FETCH_FILTERS_SUCCESS =
  "sagas/attendance/average_number_of_clients_per_class/FETCH_FILTERS_SUCCESS";
const RESET_FILTER = "sagas/attendance/average_number_of_clients_per_class/RESET_FILTER";
export const RESET_FILTER_SELECTED =
  "sagas/attendance/average_number_of_clients_per_class/RESET_FILTER_SELECTED";

export const FETCH_CHART_SUCCESS =
  "sagas/attendance/average_number_of_clients_per_class/FETCH_CHART_SUCCESS";
export const UPDATE_CHART = "sagas/attendance/average_number_of_clients_per_class/UPDATE_CHART";

export const SET_UPDATES_LOADING =
  "sagas/attendance/average_number_of_clients_per_class/SET_UPDATES_LOADING";
const UPDATE_TABLE_VIEW = "sagas/attendance/average_number_of_clients_per_class/UPDATE_TABLE_VIEW";
export const UPDATE_TABLE_VIEW_SELECTED =
  "sagas/attendance/average_number_of_clients_per_class/UPDATE_TABLE_VIEW_SELECTED";

export const SET_LOADING = "sagas/attendance/average_number_of_clients_per_class/SET_LOADING";
export const SET_FILTERS_DIRTY =
  "sagas/attendance/average_number_of_clients_per_class/SET_FILTERS_DIRTY";

const UPDATE_COMPARE_DATES =
  "sagas/attendance/average_number_of_clients_per_class/UPDATE_COMPARE_DATES";
export const UPDATE_COMPARE_DATES_SELECTED =
  "sagas/attendance/average_number_of_clients_per_class/UPDATE_COMPARE_DATES_SELECTED";
export const SET_DATES = "sagas/attendance/average_number_of_clients_per_class/SET_DATES";

export const UPDATE_DATES = "sagas/attendance/average_number_of_clients_per_class/UPDATE_DATES";

export const UPDATE_COMPARE_TYPE =
  "sagas/attendance/average_number_of_clients_per_class/UPDATE_COMPARE_TYPE";
export const UPDATE_CUSTOM_RANGE =
  "sagas/attendance/average_number_of_clients_per_class/UPDATE_CUSTOM_RANGE";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateData: createAction(UPDATE_CHART),
  updateDates: createAction(UPDATE_DATES),
  updateCompareDates: createAction(UPDATE_COMPARE_DATES),
  updateCompareType: createAction(UPDATE_COMPARE_TYPE),
  updateCustomRange: createAction(UPDATE_CUSTOM_RANGE),
  updateTableView: createAction(UPDATE_TABLE_VIEW),
  resetFilters: createAction(RESET_FILTER)
};

export default function* watchAverageNumberOfClientsPerClass() {
  yield takeLatest(FETCH_CURRENT_USER, fetchCurrentUserData);
  yield takeLatest(UPDATE_CHART, updateData);
  yield takeLatest(UPDATE_COMPARE_DATES, updateCompareDates);
  yield takeLatest(UPDATE_CUSTOM_RANGE, updateCustomRange);
  yield takeLatest(UPDATE_TABLE_VIEW, updateTableView);
  yield takeLatest(RESET_FILTER, resetFilters);
}

function* fetchCurrentUserData(data) {
  yield put({
    type: FETCH_CURRENT_USER_SUCCESS,
    payload: data.payload
  });
  yield put({ type: SET_LOADING, payload: true });
  yield put({ type: SET_FILTERS_DIRTY, payload: false });

  yield setDates();
  try {
    yield fetchFilters();
    yield fetchChart();
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* setDates() {
  const endDate = yield select(
    (state) => state.averageNumberOfClientsPerClassReducer.currentUser.calendarEndDate
  );
  const startDate = moment(endDate).startOf("month").subtract(11, "months").format("YYYY-MM-DD");

  yield put({
    type: SET_DATES,
    payload: {
      startDate,
      endDate
    }
  });
}

function* getCommonApiParams() {
  return yield select((state) => [
    state.averageNumberOfClientsPerClassReducer.currentUser.organization_id,
    state.averageNumberOfClientsPerClassReducer.currentUser.current_location_id,
    state.averageNumberOfClientsPerClassReducer.currentUser.current_object_id,
    state.averageNumberOfClientsPerClassReducer.currentUser.current_region_id,
    state.averageNumberOfClientsPerClassReducer.selectedRequestDates.startDate,
    state.averageNumberOfClientsPerClassReducer.selectedRequestDates.endDate
  ]);
}

function* fetchFilters() {
  const sagaArguments = yield getCommonApiParams();
  const [organizationId, locationId, objectId, regionId] = sagaArguments;
  if (!organizationId || !locationId || !objectId || !regionId) return;

  yield getFiltersApi(organizationId, locationId, objectId, regionId);
}

function* fetchChart() {
  const sagaArguments = yield getCommonApiParams();
  const [organizationId, locationId, objectId] = sagaArguments;

  if (!organizationId || !locationId || !objectId) return;

  const filterParams = yield select(
    (state) => state.averageNumberOfClientsPerClassReducer.selectedFilters
  );
  const filterQueryParams = Object.keys(filterParams)
    .map((paramKey) => {
      const value = filterParams[paramKey];
      if (Array.isArray(value) && value.length > 0) {
        return `&${paramKey}=${value.map((val) => val.id).join(",")}`;
      } else if (typeof value === "object" && value.id) {
        return `&${paramKey}=${value.id}`.toLowerCase();
      } else {
        return `&${paramKey}=${value}`.toLowerCase();
      }
    })
    .join("");

  yield getChartApi(...sagaArguments, filterQueryParams);
}

function* updateTableView({ payload }) {
  yield put({ type: SET_FILTERS_DIRTY, payload: false });
  yield put({ type: SET_UPDATES_LOADING, payload: true });
  yield put({ type: UPDATE_TABLE_VIEW_SELECTED, payload });
  try {
    yield fetchChart();
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* getFiltersApi(organizationId, locationId, objectId, regionId) {
  try {
    const response = yield call(
      axios.get,
      queryParams.apiVersion +
        `pages/attendance/average_numbers_of_clients_per_class_chart/filters?organization_id=${organizationId}&location_id=${locationId}&object_id=${objectId}&region_id=${regionId}`
    );

    yield put({ type: FETCH_FILTERS_SUCCESS, payload: response.data.filters });
  } catch (err) {
    console.error(err);
  }
}

function* getChartApi(
  organizationId,
  locationId,
  objectId,
  regionId,
  startDate,
  endDate,
  filterQueryParams = ""
) {
  try {
    const response = yield call(
      axios.get,
      queryParams.apiVersion +
        "pages/attendance/average_numbers_of_clients_per_class_chart" +
        "?organization_id=" +
        organizationId +
        "&location_id=" +
        locationId +
        "&object_id=" +
        objectId +
        "&region_id=" +
        regionId +
        "&start_date=" +
        startDate +
        "&end_date=" +
        endDate +
        `${filterQueryParams}`
    );

    yield put({ type: FETCH_CHART_SUCCESS, payload: response.data.data });
  } catch (err) {
    console.error(err);
  }
}

function* updateCompareDates({ payload }) {
  yield put({ type: UPDATE_COMPARE_DATES_SELECTED, payload });
}

function* updateCustomRange() {
  yield put({ type: SET_FILTERS_DIRTY, payload: true });
}

function* updateData() {
  yield put({ type: SET_FILTERS_DIRTY, payload: false });
  yield put({ type: SET_UPDATES_LOADING, payload: true });

  try {
    yield fetchChart();
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* resetFilters() {
  yield put({ type: SET_UPDATES_LOADING, payload: true });

  yield setDates();

  yield put({ type: RESET_FILTER_SELECTED });

  try {
    yield fetchChart();
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}
